export default "__VITE_ASSET__JAHa7odo__"